// extracted by mini-css-extract-plugin
export default {"link":"ChatCard_link__MF5ME","grid":"ChatCard_grid__h2VPa","content":"ChatCard_content__big7w","message":"ChatCard_message__asPBk"};